import { X } from "lucide-react";
import { ChipIcon } from "./ChipIcon";
import type { ContextChip } from "./contextChips";

/** Pill rendering one pinned context chip (composer or sent message). */
export function ContextChipBadge({
  chip,
  onRemove,
}: {
  chip: ContextChip;
  /** Omit to render a read-only chip (e.g. attached to an already-sent message). */
  onRemove?: (id: string) => void;
}) {
  return (
    <div className="group/chip flex items-center gap-1 rounded-md border border-neutral-500 py-0.5 pl-2 pr-1 text-[11px] font-semibold transition-colors hover:bg-neutral-300/20 hover:text-neutral-200">
      <ChipIcon icon={chip.icon} />

      <span className="text-neutral-500 transition-colors group-hover/chip:text-neutral-200">
        {chip.displayValue}
      </span>

      {onRemove && (
        <button
          onClick={() => onRemove(chip.id)}
          className="ml-0.5 rounded p-0.5 transition-colors hover:bg-neutral-300/40 hover:text-white group-hover/chip:bg-neutral-300/20 group-hover/chip:text-neutral-200"
        >
          <X className="h-2.5 w-2.5" />
        </button>
      )}
    </div>
  );
}
